import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'
import Search from 'components/Search'

import Banner from './components/Banner'

import classes from './Hero.module.scss'

const Hero = () => {
  return (
    <div className={clsx('Hero', classes.root)}>
      <Container className={classes.container}>
        <div className={classes.contentRoot}>
          <h1 className={classes.header}>
            GetApp, where business leaders <br />
            find software
          </h1>
          <div className={classes.autocompleteWrap}>
            <Search
              placeholderCentered
              testId="InputSearchHero"
              truncatePlaceholderMobile={false}
              colorVariant="white"
            />
          </div>
        </div>
        <Banner />
      </Container>
    </div>
  )
}

export default Hero
